<template>
  <v-row
    align="center"
    class="my-2"
  >
    <v-col
      cols="12"
      md="auto"
      lg="auto"
      xl="auto"
    >
      <v-btn
        rounded
        color="primary"
        dark
        small
        @click="handleCreateNewOppClick"
      >
        POST A JOB OPPORTUNITY
      </v-btn>
    </v-col>
    <v-col>
      Help your clients and peers by sharing opportunities across the network.<br>
      <!-- Or get support from Riverflex for an opportunity and
      <router-link
        class="purple--text"
        to="/faq/rewards"
      >
        earn up to a 40%
      </router-link> commission for a successful placement. -->
    </v-col>
  </v-row>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { trackPostJobTap } from '@/segmentAnalytics/opportunities'

@Component
export default class CreateOpportunityBtn extends Vue {

  private handleCreateNewOppClick () {
    trackPostJobTap()
    this.$emit('createNewOpp')
  }
}
</script>
